export enum QuoteStatus_Enum {
  Init,
  Requested,
  Sent,
  Accepted,
  Declined,
  Proposed
}
